import {
  CLIENT_DETAIL_LIST_REQUEST,
  CLIENT_DETAIL_LIST_SUCCESS,
  CLIENT_DETAIL_LIST_FAILURE
} from "actions/ClientDetailList/clientDetailListAction";

const initialState = {
  clientDetailList: [],
  clientDetailData: {},
};

export default function clientDetailListReducer(
  state = initialState,
  action
) {
  switch (action.type) {
          case CLIENT_DETAIL_LIST_REQUEST:
            return {
              ...state
            };
          case CLIENT_DETAIL_LIST_SUCCESS:
            return {
              ...state,
              clientDetailList: action.payload
            };
          case CLIENT_DETAIL_LIST_FAILURE:
            return {
              ...state,
              error: action.payload
            };
    case 'CLIENTDETAILDATA':
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          clientDetailData: action.payload
        };
      }
    default:
      return state;
  }
}